/**
 * Models a provider
 */

import Brace from "backbone.brace";
import Groups from "../../collections/chart-reviews/provider-groups";

const Model = Brace.Model.extend({
  namedAttributes: {
    id: Number,
    providerNumber: String,
    firstName: String,
    lastName: String,
    city: String,
    zip: Number,
    state: String,
    specialistType: String,
    nationalProviderId: String,
    isPcp: Boolean,
    groups: Groups,
    asOfDate: Date,
  },
  defaults: {
    id: null,
    providerNumber: null,
    firstName: null,
    lastName: null,
    city: null,
    zip: null,
    state: null,
    specialistType: null,
    nationalProviderId: null,
    isPcp: null,
    groups: null,
    asOfDate: null,
  },
});

export { Model as default };
